module.exports = __webpack_public_path__ + "static/img/Ellipse 2 (Stroke).b1eb2491.png";